import React, { Component } from "react"
import Select from "../../../components/Select"

class Relay extends Component {

    handleChange = (field, value) => {
        const detalhes = Object.assign({}, this.props.detalhes)
        const errors = Object.assign({}, this.props.errors)

        detalhes[field] = value

        if(field === "is_relay" || field === "is_relay_ed") {

            if(detalhes.is_relay == false && detalhes.is_relay_ed == false) {
                if("relay_second_channel_ack_offset" in errors) {
                    delete errors["relay_second_channel_ack_offset"]
                    this.props.setErrors(errors)
                }
            }

            const notChecked = value === false
            const fieldsObject = {
                is_relay: ["relay_cad_periodicity", "relay_join_req_limit_bucket_size", "relay_notify_limit_bucket_size", "relay_global_uplink_limit_bucket_size", "relay_overall_limit_bucket_size"],
                is_relay_ed: ["relay_ed_activation_mode", "relay_ed_smart_enable_level", "relay_ed_uplink_limit_bucket_size"]
            }

            if(notChecked) {
                const fields = fieldsObject[field]

                for(let fieldDetalhes in detalhes) {

                    if(fields.includes(fieldDetalhes)) {
                        if(fieldDetalhes in errors) {
                            delete errors[fieldDetalhes]
                            this.props.setErrors(errors) 
                        }
                    }
                }
            }
        } 
    
        if(field in errors) {
            delete errors[field]
            this.props.setErrors(errors)
        }
        
        this.props.setDetalhes(detalhes)
    }
    

    render() {
        const { detalhes, optionsSelect, errors, isTemplate } = this.props

        return(
            <div className="hdv-form-default">

                <div className="row">
                    <div className="col-md-6">
                        <label className="required label-truncate" htmlFor="is_relay" title="O dispositivo é um relé">O dispositivo é um relé</label>
                        <input
                            type='checkbox'
                            checked={detalhes.is_relay}
                            id="is_relay"
                            onChange={(e) => this.handleChange("is_relay", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-is_relay'>{ errors["is_relay"] ?? ""  }</span>
                    </div>

                    <div className="col-md-6" style={{display: !detalhes.is_relay ? "none" : "block"}}>
                        <label className="required label-truncate" htmlFor="relay_enabled" title="Relé habilitado">Relé habilitado</label>
                        <input
                            type='checkbox'
                            checked={detalhes.relay_enabled}
                            id="relay_enabled"
                            onChange={(e) => this.handleChange("relay_enabled", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-relay_enabled'>{ errors["relay_enabled"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required label-truncate" htmlFor="is_relay_ed" title="O dispositivo é um dispositivo final com capacidade de retransmissão">O dispositivo é um dispositivo final com capacidade de retransmissão</label>
                        <input
                            type='checkbox'
                            checked={detalhes.is_relay_ed}
                            id="is_relay_ed"
                            onChange={(e) => this.handleChange("is_relay_ed", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-is_relay_ed'>{ errors["is_relay_ed"] ?? ""  }</span>
                    </div>

                    <div className="col-md-6" style={{display: !detalhes.is_relay_ed ? "none" : "block"}}>
                        <label className="required label-truncate" htmlFor="relay_ed_relay_only" title="Usa somente Relé (dispositivo final)">Usar somente Relé (dispositivo final)</label>
                        <input
                            type='checkbox'
                            checked={detalhes.relay_ed_relay_only}
                            id="relay_ed_relay_only"
                            onChange={(e) => this.handleChange("relay_ed_relay_only", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-relay_ed_relay_only'>{ errors["relay_ed_relay_only"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <label className="required label-truncate" htmlFor="relay_default_channel_index" title="Índice de canal padrão">Índice de canal padrão</label>
                        <input
                            type='text'
                            value={detalhes.relay_default_channel_index ?? ""}
                            disabled={detalhes.is_relay == false && detalhes.is_relay_ed === false || isTemplate}
                            id="relay_default_channel_index"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_default_channel_index", value)
                            }}
                        />
                        <span id='validacao-relay_default_channel_index'>{ errors["relay_default_channel_index"] ?? ""  }</span>
                    </div>

                    <div className="col-md-4">
                        <label className="required label-truncate" htmlFor="relay_second_channel_freq" title="Frequência do segundo canal (Hz)">Frequência do segundo canal (Hz)</label>
                        <input
                            type='text'
                            value={detalhes.relay_second_channel_freq ?? ""}
                            disabled={detalhes.is_relay == false && detalhes.is_relay_ed === false || isTemplate}
                            id="relay_second_channel_freq"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_second_channel_freq", value)
                            }}
                        />
                        <span id='validacao-relay_second_channel_freq'>{ errors["relay_second_channel_freq"] ?? ""  }</span>
                    </div>

                    <div className="col-md-4">
                        <label className="required label-truncate" htmlFor="relay_second_channel_dr" title="Taxa de dados do segundo canal">Taxa de dados do segundo canal</label>
                        <input
                            type='text'
                            value={detalhes.relay_second_channel_dr ?? ""}
                            disabled={detalhes.is_relay == false && detalhes.is_relay_ed === false || isTemplate}
                            id="relay_second_channel_dr"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_second_channel_dr", value)
                            }}
                        />
                        <span id='validacao-relay_second_channel_dr'>{ errors["relay_second_channel_dr"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required label-truncate" title="Deslocamento ACK do segundo canal">Deslocamento ACK do segundo canal</label>
                        <Select
                            options={optionsSelect.relay_second_channel_ack_offset}
                            value={detalhes.relay_second_channel_ack_offset}
                            onChange={(e) => this.handleChange("relay_second_channel_ack_offset", e)}
                            disabled={detalhes.is_relay == false && detalhes.is_relay_ed === false || isTemplate}
                        />
                        <span id='validacao-relay_second_channel_ack_offset'>{ errors["relay_second_channel_ack_offset"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className="required label-truncate" title="Periodicidade CAD">Periodicidade CAD</label>
                        <Select
                            options={optionsSelect.relay_cad_periodicity}
                            disabled={!detalhes.is_relay || isTemplate}
                            value={detalhes.relay_cad_periodicity}
                            onChange={(e) => this.handleChange("relay_cad_periodicity", e)}
                        />
                        <span id='validacao-relay_cad_periodicity'>{ errors["relay_cad_periodicity"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <label className="required label-truncate" title="Modo de ativação do dispositivo final">Modo de ativação do dispositivo final</label>
                        <Select
                            options={optionsSelect.relay_ed_activation_mode}
                            value={detalhes.relay_ed_activation_mode}
                            onChange={(e) => this.handleChange("relay_ed_activation_mode", e)}
                            disabled={!detalhes.is_relay_ed || isTemplate}
                        />
                        <span id='validacao-relay_ed_activation_mode'>{ errors["relay_ed_activation_mode"] ?? ""  }</span>
                    </div>
                    <div className="col-md-4">
                        <label className="required label-truncate" title="Nível de ativação inteligente">Nível de ativação inteligente</label>
                        <Select
                            options={optionsSelect.relay_ed_smart_enable_level}
                            value={detalhes.relay_ed_smart_enable_level}
                            onChange={(e) => this.handleChange("relay_ed_smart_enable_level", e)}
                            disabled={!detalhes.is_relay_ed || isTemplate}
                        />
                        <span id='validacao-relay_ed_smart_enable_level'>{ errors["relay_ed_smart_enable_level"] ?? ""  }</span>
                    </div>
                    <div className="col-md-4">
                        <label className="required label-truncate" htmlFor="relay_ed_back_off" title="Recuar">Recuar</label>
                        <input
                            type='text'
                            value={detalhes.relay_ed_back_off ?? ""}
                            disabled={!detalhes.is_relay_ed || isTemplate}
                            id="relay_ed_back_off"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_ed_back_off", value)
                            }}
                        />
                        <span id='validacao-relay_ed_back_off'>{ errors["relay_ed_back_off"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-8">
                        <label className="required label-truncate" title="Tamanho do bucket de limite de uplink do dispositivo final">Tamanho do bucket de limite de uplink do dispositivo final</label>
                        <Select
                            options={optionsSelect.relay_ed_uplink_limit_bucket_size}
                            value={detalhes.relay_ed_uplink_limit_bucket_size}
                            onChange={(e) => this.handleChange("relay_ed_uplink_limit_bucket_size", e)}
                            disabled={!detalhes.is_relay_ed || isTemplate}
                        />
                        <span id='validacao-relay_ed_uplink_limit_bucket_size'>{ errors["relay_ed_uplink_limit_bucket_size"] ?? ""  }</span>
                    </div>
                    <div className="col-md-4">
                        <label className="required label-truncate" htmlFor="relay_ed_uplink_limit_reload_rate" title="Taxa de recarga do limite de uplink do dispositivo final">Taxa de recarga do limite de uplink do dispositivo final</label>
                        <input
                            type='text'
                            value={detalhes.relay_ed_uplink_limit_reload_rate ?? ""}
                            id="relay_ed_uplink_limit_reload_rate"
                            disabled={!detalhes.is_relay_ed || isTemplate}
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_ed_uplink_limit_reload_rate", value)
                            }}
                        />
                        <span id='validacao-relay_ed_uplink_limit_reload_rate'>{ errors["relay_ed_uplink_limit_reload_rate"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <label className="required label-truncate" title="Limite do tamanho do bucket de solicitação de junção">Limite do tamanho do bucket de solicitação de junção</label>
                        <Select
                            options={optionsSelect.relay_join_req_limit_bucket_size}
                            value={detalhes.relay_join_req_limit_bucket_size}
                            onChange={(e) => this.handleChange("relay_join_req_limit_bucket_size", e)}
                            disabled={!detalhes.is_relay || isTemplate}
                        />
                        <span id='validacao-relay_join_req_limit_bucket_size'>{ errors["relay_join_req_limit_bucket_size"] ?? ""  }</span>
                    </div>
                    <div className="col-md-3">
                        <label className="required label-truncate" htmlFor="relay_join_req_limit_reload_rate" title="Taxa de recarga do limite de solicitação de junção">Taxa de recarga do limite de solicitação de junção</label>
                        <input
                            type='text'
                            value={detalhes.relay_join_req_limit_reload_rate ?? ""}
                            disabled={!detalhes.is_relay || isTemplate}
                            id="relay_join_req_limit_reload_rate"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_join_req_limit_reload_rate", value)
                            }}
                        />
                        <span id='validacao-relay_join_req_limit_reload_rate'>{ errors["relay_join_req_limit_reload_rate"] ?? ""  }</span>
                    </div>
                    <div className="col-md-3">
                        <label className="required label-truncate" title="Notificar tamanho limite do bucket">Notificar tamanho limite do bucket</label>
                        <Select
                            options={optionsSelect.relay_notify_limit_bucket_size}
                            value={detalhes.relay_notify_limit_bucket_size}
                            onChange={(e) => this.handleChange("relay_notify_limit_bucket_size", e)}
                            disabled={!detalhes.is_relay || isTemplate}
                        />
                        <span id='validacao-relay_notify_limit_bucket_size'>{ errors["relay_notify_limit_bucket_size"] ?? ""  }</span>
                    </div>
                    <div className="col-md-3">
                        <label className="required label-truncate" htmlFor="relay_notify_limit_reload_rate" title="Notificar taxa de recarga limite">Notificar taxa de recarga limite</label>
                        <input
                            type='text'
                            value={detalhes.relay_notify_limit_reload_rate ?? ""}
                            disabled={!detalhes.is_relay || isTemplate}
                            id="relay_notify_limit_reload_rate"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_notify_limit_reload_rate", value)
                            }}
                        />
                        <span id='validacao-relay_notify_limit_reload_rate'>{ errors["relay_notify_limit_reload_rate"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3">
                        <label className="required label-truncate" title="Tamanho do bucket do limite de uplink global">Tamanho do bucket do limite de uplink global</label>
                        <Select
                            options={optionsSelect.relay_global_uplink_limit_bucket_size}
                            value={detalhes.relay_global_uplink_limit_bucket_size}
                            onChange={(e) => this.handleChange("relay_global_uplink_limit_bucket_size", e)}
                            disabled={!detalhes.is_relay || isTemplate}
                        />
                        <span id='validacao-relay_global_uplink_limit_bucket_size'>{ errors["relay_global_uplink_limit_bucket_size"] ?? ""  }</span>
                    </div>
                    <div className="col-md-3">
                        <label className="required label-truncate" htmlFor="relay_global_uplink_limit_reload_rate" title="Taxa de recarga do limite de uplink global">Taxa de recarga do limite de uplink global</label>
                        <input
                            type='text'
                            value={detalhes.relay_global_uplink_limit_reload_rate ?? ""}
                            disabled={!detalhes.is_relay || isTemplate}
                            id="relay_global_uplink_limit_reload_rate"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_global_uplink_limit_reload_rate", value)
                            }}
                        />
                        <span id='validacao-relay_global_uplink_limit_reload_rate'>{ errors["relay_global_uplink_limit_reload_rate"] ?? ""  }</span>
                    </div>
                    <div className="col-md-3">
                        <label className="required label-truncate" title="Tamanho do limite geral do bucket">Tamanho do limite geral do bucket</label>
                        <Select
                            options={optionsSelect.relay_overall_limit_bucket_size}
                            value={detalhes.relay_overall_limit_bucket_size}
                            onChange={(e) => this.handleChange("relay_overall_limit_bucket_size", e)}
                            disabled={!detalhes.is_relay || isTemplate}
                        />
                        <span id='validacao-relay_overall_limit_bucket_size'>{ errors["relay_overall_limit_bucket_size"] ?? ""  }</span>
                    </div>
                    <div className="col-md-3">
                        <label className="required label-truncate" htmlFor="relay_overall_limit_reload_rate" title="Taxa de recarga limite geral">Taxa de recarga limite geral</label>
                        <input
                            type='text'
                            value={detalhes.relay_overall_limit_reload_rate ?? ""}
                            disabled={!detalhes.is_relay || isTemplate}
                            id="relay_overall_limit_reload_rate"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("relay_overall_limit_reload_rate", value)
                            }}
                        />
                        <span id='validacao-relay_overall_limit_reload_rate'>{ errors["relay_overall_limit_reload_rate"] ?? ""  }</span>
                    </div>
                </div>
                
            </div>
        )
    }
}

export default Relay